import UpcomingLiveEvent from './UpcomingLiveEvent'

export default UpcomingLiveEvent
